import styled, { StyledComponent } from 'styled-components';

export const Wrapper = styled.div`
  gap: 10px;
  width: 100%;
  background: #ffffff;
  border-radius: 4px;
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding: 8px 16px;
`;

export const Title = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: rgba(0, 0, 0, 0.88);
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`;

export const RuleContainer = styled.div`
  display: flex;
  padding: 10px 16px;
`;

export const MappingRulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Holder = styled.div`
  height: 10px;
  width: 100%;
`;

export const EventLimitToolTips: StyledComponent<'span', any, { type?: 'error' }> = styled.span<{
  type?: 'error';
}>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  margin-right: 8px;
  height: 28px;
  border-radius: 4px;
  flex-grow: 0;
  letter-spacing: -0.01em;
  font-style: normal;
  font-size: 14px;

  font-weight: ${(props) => (props.type === 'error' ? '500' : '400')};
  background: ${(props) => (props.type === 'error' ? '#fff3f3' : '#f7f7f7')};
  color: ${(props) => (props.type === 'error' ? '#d0021b' : '#494949')};
`;
